import { Section } from '../layout/Section'
import { services } from '../../data/services'

export function Services() {
    return (
        <Section id="solucoes" background="light">
            <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-bold text-dpxp-dark mb-4">
                    Nossos Serviços
                </h2>
                <p className="text-xl text-dpxp-muted max-w-3xl mx-auto">
                    Desenhamos o sistema estratégico que o seu ecossistema precisa
                </p>
            </div>

            {/* Services - Each card in full width row with image on side */}
            <div className="space-y-6">
                {services.map((service, index) => {
                    const Icon = service.icon
                    const isEven = index % 2 === 0

                    return (
                        <div
                            key={service.id}
                            className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-6 lg:gap-8 items-center bg-white rounded-2xl p-6 lg:p-8 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300`}
                        >
                            {/* Title - Always first on mobile, beside image on desktop */}
                            <div className="flex-1 order-1 lg:order-none">
                                {/* Title + Icon */}
                                <div className="flex items-center gap-4 mb-4">
                                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-dpxp-primary to-dpxp-secondary flex items-center justify-center text-white shadow-lg">
                                        <Icon className="w-6 h-6" />
                                    </div>
                                    <h3 className="text-xl lg:text-2xl font-bold text-dpxp-dark">{service.title}</h3>
                                </div>
                                {/* Description - Hidden on mobile, shown on desktop */}
                                <p className="hidden lg:block text-dpxp-muted text-base lg:text-lg leading-relaxed">
                                    {service.description}
                                </p>
                            </div>

                            {/* Image - Middle on mobile */}
                            {service.image && (
                                <div className="w-full lg:w-1/3 flex justify-center order-2 lg:order-none">
                                    <img
                                        src={service.image}
                                        alt={service.title}
                                        className="h-40 lg:h-56 w-auto object-contain"
                                    />
                                </div>
                            )}

                            {/* Description - Last on mobile */}
                            <p className="lg:hidden text-dpxp-muted text-base leading-relaxed order-3">
                                {service.description}
                            </p>
                        </div>
                    )
                })}
            </div>
        </Section>
    )
}
